exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--wizard{overflow:visible}.v-card--wizard .v-tabs-bar{height:56px;padding:0 8px}.v-card--wizard .v-slide-group__wrapper{overflow:visible}.v-card--wizard .v-tabs-slider{border-radius:4px}.v-card--wizard .v-slide-group__wrapper{contain:none}", ""]);

// exports
